import { Component, OnInit } from "@angular/core";

import * as Sentry from "@sentry/browser";
import { Observable } from "rxjs";

import { AlertService } from "#utils/alert-service/alert-service.service";
import { Router } from "@angular/router";
import { filter, first } from "rxjs/operators";
import { AuthService } from "#root/core/auth/auth.service";
import { FeatureFlagEnum } from "#root/config/enums/feature-flag.enum";
import { FeatureFlagService } from "#root/config/services/feature-flag/feature-flag.service";
import { PaymentOrdersService } from "#services/payment-orders/payment-orders.services";
import { GoogleAnalyticsService } from "./http/external-services/google/analytics.service";
import { GoogleMapsLoaderService } from "./http/external-services/google/maps-loader.service";
import { PermissionRouterService } from "./shared/services/permissions-router.service";

declare const gtag: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  /**
   * Constructor
   */
  constructor(
    private readonly alertService: AlertService,
    private readonly router: Router,
    private readonly analyticsService: GoogleAnalyticsService,
    private readonly mapsLoader: GoogleMapsLoaderService,
    private readonly permissionRouterService: PermissionRouterService,
    private readonly authService: AuthService,
    private readonly featureFlagService: FeatureFlagService,
    private readonly paymentOrdersService: PaymentOrdersService
  ) {
    this.changelog();

    if (localStorage.getItem("idUser")) {
      // Save user Sentry
      Sentry.setUser({
        id: localStorage.getItem("idUser"),
        email: localStorage.getItem("email"),
        username: localStorage.getItem("fullName"),
      });
    }
  }

  ngOnInit(): void {
    this.analyticsService.initialize();
    this.permissionRouterService.initPermissionWatcher();
    this.mapsLoader.load();
    this.verifyPendingInvoicesOnStartup();
  }

  private verifyPendingInvoicesOnStartup(): void {
    this.authService.loggedInUser$
      .pipe(
        filter(
          (user) =>
            !!user?.permissionsMap?.CanSyncPaymentOrderInvoice &&
            this.featureFlagService.isEnabled(FeatureFlagEnum.ERP_INTEGRATION)
        ),
        first()
      )
      .subscribe(() =>
        this.paymentOrdersService.VerifyPendingInvoices(false).subscribe({ error: () => {} })
      );
  }

  errorMessage$: Observable<{
    message: string;
    title?: string;
    errors: Array<string> | null;
  }> = this.alertService.message$;
  updateMessage$: Observable<string> = this.alertService.updateMessage$;
  saveMessage$: Observable<string> = this.alertService.saveMessage$;
  warningMessage$: Observable<string> = this.alertService.warningMessage$;

  public async changelog() {
    // Method intentionally empty - version changelog feature disabled
  }
}
